import { render, staticRenderFns } from "./CMAccountActivation.vue?vue&type=template&id=f7d8efd8&"
import script from "./CMAccountActivation.vue?vue&type=script&lang=js&"
export * from "./CMAccountActivation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f7d8efd8')) {
      api.createRecord('f7d8efd8', component.options)
    } else {
      api.reload('f7d8efd8', component.options)
    }
    module.hot.accept("./CMAccountActivation.vue?vue&type=template&id=f7d8efd8&", function () {
      api.rerender('f7d8efd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/popups/user/CMAccountActivation.vue"
export default component.exports